// RISKS.md/P2.35: the '/sw/' argument is REQUIRED. A bare `getRegistration()` matches the
// current PAGE's URL against registration scopes, and this worker's scope is '/sw/' (the script
// directory), which never matches '/join/<token>' — so it always resolves undefined.
const registerServiceWorker = async () => {
  const registration = await navigator.serviceWorker.getRegistration('/sw/')
  if (!registration) {
    return navigator.serviceWorker.register('/sw/sw.js', { type: 'module' })
  }
  // RISKS.md/P1.33: no page is in the worker's scope, so nothing else checks it for updates.
  // Not awaited: it rejects when /sw/sw.js fails to load, and the join awaits this function.
  // Not register(): for an unchanged script URL it returns this registration unchecked.
  registration.update().catch(e => console.warn('checking the service worker for an update failed', e))
  return registration
}

export {
  registerServiceWorker,
}
